module.exports = __webpack_public_path__ + "img/hdsw.4571ecab.jpg";